import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { forwardRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { APP_CONSTANTS } from '../URLConstants';
import { NOTIFICATION_WIDTH_XL, NOTIFICATION_WIDTH_XLM } from '../layouts/dashboard';
import { useAuth } from './customContextProviders/AuthContext';

const Page = forwardRef(({ children, title = '', ...other }, ref) => {
  const location = useLocation();
  const { userLoginOrg } = useAuth();

  const isChanakya =
    userLoginOrg === APP_CONSTANTS?.SBI_CLIENT_IDENTIFIER &&
    location?.pathname !== '/login' &&
    location?.pathname !== '/validateotp' &&
    location?.pathname !== '/forgotpassword';

  return (
    <Box
      ref={ref}
      {...other}
      sx={{
        paddingLeft: { xs: 1, md: 0 },
        paddingRight: { xs: 1, md: 0 },
        height: '100%',
        width: {
          xs: '100%',
          lg: isChanakya ? `calc(100% - ${NOTIFICATION_WIDTH_XL}px)` : '100%',
          md: isChanakya ? `calc(100% - ${NOTIFICATION_WIDTH_XL}px)` : '100%',
          xl: isChanakya ? `calc(100% - ${NOTIFICATION_WIDTH_XLM}px)` : '100%',
        }
      }}
    >
      <Helmet>
        <meta
          name="description"
          content={`For ${
            process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ID ===
            APP_CONSTANTS?.CBI_CLIENT_IDENTIFIER
              ? ''
              : process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ID
          } AudioCube`}
        />
        <meta name="keywords" content="AudioCube, AudioPod, SoundBox, SoundPod" />
        <meta name="author" content="Proxgy Team" />
        <title>{title}</title>
      </Helmet>

      {children}
    </Box>
  );
});

Page.displayName = 'Page';

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string
};

export default Page;
